<template>
    <div class="max">
        <header v-if="ispc">
            <div class="row">
            <div class="container">
              <img src="@/assets/img/logo1.png" alt="" />
              <div>
                  <span><a href="#specialty">教学特点</a></span>
                  <span> <a href="#mien">教师风采</a></span>
                  <span> <a href="#community">家长社区</a></span>
              </div>
            </div>
            </div>
        </header>
        <section>
            <div class="mask">
            </div>

            <div class="row">
            <div class="container">
                <div class="left">
                    <div>
                        <h1>精英补习班</h1>
                        <h1>暑期学霸炼成记</h1>
                    </div>
                    <div>
                        <span>6-12年级 查漏补缺 | 预习复习</span>
                    </div>
                </div>
                <div class="right">
                    <!-- <img src="@/assets/img/mon.png" alt="" /> -->
                    <div class="forms_submit">
                        <div class="toplog">
                            <h1>免费试课报名表</h1>
                            <!-- <span class="subTitle">价值<span style="color: #ff5979">$299</span>课程大礼包</span>
                            <span class="subBreif">（2节直播课+独家教材）</span> -->
                        </div>
                        <el-form style="width: 100%" label-position="top" :rules="rules" label-width="80px" ref="ruleForm" :model="formLabelAlign" hide-required-asterisk>
                            <el-form-item label="孩子昵称">
                                <el-input v-model="formLabelAlign.child_nickname" placeholder="孩子昵称" class="infocus"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号码" prop="mobile" >
                                <el-input oninput="value=value.replace(/\D/gi,'')" v-model="formLabelAlign.mobile" placeholder="请输入您的手机号码" :maxlength="max" class="infocus">
                                    <el-select ref="select" :placeholder="$t('Country Code')" v-model="formLabelAlign.country_code" slot="prepend" style="width: 156px" @change="changeCode" class="infocus">
                                        <el-option v-for="(item, index) in countries" :label="` ${item.zh} `" :key="item" :value="item.id">
                                            <div class="selectoption">
                                                <span> <img :src="item.flag" alt=""> {{item.zh}} </span>
                                                <span> +{{ item.country_code }}</span>
                                            </div>

                                        </el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="电子邮箱" prop="email">
                                <el-input v-model="formLabelAlign.email" placeholder="example@gmail.com" class="infocus"></el-input>
                            </el-form-item>
                            <el-form-item label="微信号">
                                <el-input v-model="formLabelAlign.wechat_id" placeholder="wechat ID" class="infocus"></el-input>
                            </el-form-item>
                        </el-form>
                        <button @click="submit('ruleForm')">点击免费试课</button>
                    </div>
                </div>
            </div>
            </div>
                <div class="rightBTM">
                        <div></div>
                </div>
                <div class="leftBTM">
                    <div></div>
                </div>
            <!-- <div class="bgred" v-if="!ispc"></div> -->
        </section>
        <div class="bodypink">

            <div class="row">
            <div class="container">
            <!-- <div class="classover potion">
                <div class="title" id="specialty">
                </div>
            </div> -->

            <div class="four">
                <div class="titleen">
                    <img src="../assets/img/xinxin1.png" alt="" class="img1">
                    <img src="../assets/img/xinxin2.png" alt="" class="img2">
                    <img src="../assets/img/xinxin3.png" alt="" class="img3">
                </div>
                <div class="title-1">
                    Classover 特色
                </div>
                <img src="@/assets/img/classoverred.png" alt="" />
                <div class="titleon">
                    <img src="../assets/img/xinxin3.png" alt="" class="img1">
                    <img src="../assets/img/xinxin2.png" alt="" class="img2">
                    <img src="../assets/img/xinxin1.png" alt="" class="img3">
                </div>

                <div class="flexsum">
                        <div class="flex-line">

                        <span>美国中学在职教师+ <p class="onpan">藤校毕业精英</p></span>
                        <span>老师团队有严格的质量把控，包括教学经验筛选，六轮面试，视频试讲，背景调查等流程。老师录取率只有不到5%。  </span>


                        </div>
                        <div class="flex-line">

                                <span> 独创“TALENT”教学</span>
                                <span class="twospan">“TALENT”精英宝贝6步教学法综合中西方教育文化的精华，经过10,000+学员的亲身体验，相较传统教学方法，学习效果更显著。</span>
                               <div>
                                   <img src="../assets/img/Rectangle1.png" alt="">
                               </div>


                        </div>
                        <div class="flex-line threespan">

                                <span>孩子轻松提高成绩，<p class="onpan">无限课程随时预约</p> </span>
                                <span >面向6-12年级，名师直播，课程辅导，无限制课时解答作业难题，教懂为止，让学习不再困难。</span>

                        </div>
                </div>

            </div>
            </div>
            </div>
        </div>
        <div class="bodypink bodysses ">

            <div class="row rowimg ">
                <img src="../assets/img/student.png" alt="" style="width:100%; " class="imgsen">
                <div class="musk" ></div>
            <div class="container  ">
            <div class="pinkTwo">

                    <div class="two_tit">
                        <span>学在得益，追求卓越</span>
                        <span>我们提供包括英语，数学，化学，物理，生物等中学科目</span>
                        <div class="centerimg">
                            <div  class="cenimgone">
                                <img src="../assets/img/icons.png" alt="">
                                <img src="../assets/img/Frameto.png" alt="" class="topimg">
                                <span>英语</span>
                            </div>
                            <div class="cenimgone" >
                                <img src="../assets/img/Group 11071.png" alt="">
                                <img src="../assets/img/Frameto.png" alt="" class="topimg">
                                <span>数学</span>
                            </div>
                        </div>
                        <span class="spanclass">更多科目即将到来，敬请期待！</span>
                    </div>


                </div>
             </div>
        </div>
        </div>
        <div class="bodypink bodyred " style="background: #1068AF; ">
            <!-- <img src="../assets/img/Ellipse_img1.png" class="img1" alt="">
            <img src="../assets/img/Ellipse_img2.png" class="img2" alt="">
            <img src="../assets/img/Elipse_img3.png" class="img3" alt=""> -->
            <div class="row ">
            <div class="container  ">
              <div class="youshiBox">

                <div class="classover moliepost">
                    <!-- 优势 -->
                    <div class="titleen2 ">
                        <img src="../assets/img/xinxin4.png" alt="" class="img1">
                        <img src="../assets/img/xinxin5.png" alt="" class="img2">
                        <img src="../assets/img/xinxin6.png" alt="" class=" img4">
                    </div>
                    <div class="title-2" id="specialty">
                        <p>Classover 优势</p>
                        <img src="@/assets/img/classoverimg.png" alt="" />
                    </div>
                     <div class="titleon2 ">
                        <img src="../assets/img/xinxin6.png" alt="" class="img1">
                        <img src="../assets/img/xinxin5.png" alt="" class="img2">
                        <img src="../assets/img/xinxin4.png" alt="" class=" img4">
                    </div>

                </div>
                <div class="THRbox">
                  <div class="whitebox">
                      <span>课程多样性</span>
                      <span>充分发掘潜能，全面培养兴趣</span>
                  </div>
                  <div class="whitebox">
                      <span>时间灵活</span>
                      <span>随时随地，想学就学</span>
                  </div>
                  <div class="whitebox">
                      <span>教学高效</span>
                      <span>顶尖师资力量，1至6人精品小班</span>
                  </div>
                </div>
                <!-- <div class="iphone">
                    <img src="@/assets/img/Rectangle25.png" alt="" />
                </div> -->
              </div>
              <!-- <div class="jiangpai"></div> -->
              <!-- <div class="guide"><img src="../assets/img/Groupguird.png" alt="" /></div> -->
              <!-- <div class="guideApp" v-if="!ispc"></div> -->
              <!-- <div class="cerebrum" v-if="ispc"></div> -->
              <!-- <div class="appCircleRIG">
                  <div></div>
              </div> -->
              <!-- <div class="pcCircleBTM" v-if="ispc">
                  <div></div>
              </div> -->
            </div>
            </div>
        </div>
        <div class="bgWhite">

            <div class="row">
            <div class="container whiteBg">
                <!-- <div class="cerebrumAPP"></div> -->
                <div id="mien">Classover的老师们</div>
                <!-- <div class="videoStyle">
                    <div>
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/e8iR7Mut3k8"
                            title="Embedded video"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                    <div>
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/hyfnLTdSL5g"
                            title="Embedded video"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                    <div>
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/6iCx5aii2bg"
                            title="Embedded video"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                    <div>
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/sGFtuBbX-I0"
                            title="Embedded video"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                </div> -->

                <div class="video_box">
                  <!-- <div class="video_info"><video width="100%" height="100%" controls="" :autoplay="false" name="media"><source src="https://app.classover.com/video/01.mp4" type="video/mp4"></video></div>
                  <div class="video_info"><video width="100%" height="100%" controls="" :autoplay="false" name="media"><source src="https://app.classover.com/video/02.mp4" type="video/mp4"></video></div>
                  <div class="video_info"><video width="100%" height="100%" controls="" :autoplay="false" name="media"><source src="https://app.classover.com/video/03.mp4" type="video/mp4"></video></div>
                  <div class="video_info"><video width="100%" height="100%" controls="" :autoplay="false" name="media"><source src="https://app.classover.com/video/04.mp4" type="video/mp4"></video></div> -->

                    <div class="video_info">
                        <video width="100%" height="100%" controls="" :autoplay="false" name="media" poster="@/assets/img/one.png"><source src="../assets/img/m1.mp4" type="video/mp4"></video>
                    </div>
                    <div class="video_info">
                        <video width="100%" height="100%" controls="" :autoplay="false" name="media" poster="@/assets/img/two.png"><source src="../assets/img/m2.mp4" type="video/mp4"></video>
                    </div>
                </div>
                <div class="swiperfor" id="community">
                    <div>READY, SET, GO</div>
                    <div>10000+家庭的选择</div>
                </div>
                <!-- TrustBox widget - Carousel -->
                <!-- <div class="trustpilot-widget" data-locale="en-US" data-template-id="53aa8912dec7e10d38f59f36" data-businessunit-id="617b20b93e0299505641bb2a" data-style-height="140px" data-style-width="100%" data-theme="light" data-stars="1,2,3,4,5" data-review-languages="en">
                  Trustpilot
                </div> -->

                <!-- End TrustBox widget -->
                <div class="star-container">
                    <div class="star-left">
                        <label for="">Excellent</label>
                        <img style="margin-top: 8px" class="star-img-big" src="../assets/img/star-big.png" alt="star-big" />
                        <span style="margin-top: 9px">Based on  <span style="text-decoration:underline">276 reviews</span></span>
                        <img style="margin-top: 18px" src="../assets/img/kissclipart.png" alt="kissclipart" />
                    </div>
                    <div class="start-content">
                        <div class="lo-7-info-1 info-feed">
                            <img src="../assets/img/star-big.png" alt="">
                            <h6>My daughter has attended classover…</h6>
                            <p>My daughter has attended classover class for more than one year. She likes it a lot...</p>
                        </div>
                        <div class="lo-7-info-2 info-feed">
                            <img src="../assets/img/star-big.png" alt="">
                            <h6>Interesting classes</h6>
                            <p>My son is taking reading writing and math classes for more than 1 year. He really enjoys learning..</p>
                        </div>
                        <div class="lo-7-info-3 info-feed">
                            <img src="../assets/img/star-big.png" alt="">
                            <h6>I especially like classover's small…</h6>
                            <p>I especially like classover's small class system, so that every child can be asked questions many times...</p>
                        </div>
                    </div>

                </div>
                <!-- <div class="btn_lq" @click="toTop">点击免费领取</div> -->
                <!-- <img src="@/assets/img/balls.png" alt="" /> -->
            </div>
            </div>
        </div>
        <footer>

            <!-- <img src="@/assets/img/fooright.png" class="img1" alt="" />
            <img src="@/assets/img/fooright1.png" class="img2" alt="" /> -->
            <!-- <img src="@/assets/img/Ellipse_m_1.png" class="img_m3" alt="" />
            <img src="@/assets/img/Ellipse_m_2.png" class="img_m4" alt="" /> -->
            <img class="fooimg2" src="@/assets/img/bigmonkey.png" alt="" />
            <div class="row">
            <div class="container">
                <div class="footer_box">
                    <h3>我们的使命</h3>
                    <h1 class="aboutus">关于Classover</h1>
                    <div class="londtitle">
                        Classover是美国本土的一站式线上远程教育的开拓者,
                        坐落于纽约曼哈顿。旨在为儿童和青少年打造最优质的线上课程平台。严选TOP5%美国在职教师让线上互动式教育同线下教育一样高效有趣。Classover的课程设置专门针对4-12岁孩子的智力发展趋势，在融合了传统学术要求知识点的同时，扩宽孩子的思维，提升学习兴趣，让孩子从课程中探索未知在欢笑中温故知新。
                    </div>
                    <!-- <div class="btn_yellow" @click="toTop">点击免费领取</div> -->
                    <!-- <div class="circleRightTop" v-if="ispc">
                    </div>
                    <div v-if="!ispc" class="circleRightTopApp">
                        <img src="@/assets/img/fooapp.png" alt="" />
                        <img src="@/assets/img/fooapp1.png" alt="" />
                    </div> -->
                    <!-- <img class="fooimg3" src="@/assets/img/bigjiangbei.png" alt="" /> -->
                </div>
                <!-- <img class="fooimg1" src="@/assets/img/jianbihe.png" alt="" /> -->
            </div>
            </div>
        </footer>
        <div class="interbox" v-if="btnFlag"  @click="toTop">点击免费试课</div>
       <div class="interbox" v-if="btnFlag"  @click="handleLogin" > {{$t('Claim FREE Package')}} </div>
        <div v-show="dialogVisible" class="show-captcha"  @click="closebg">
        <div  class="show-captcha-div" @click.stop>
                <div ref="captcha"></div>
                <!-- <button ref="popups" class=" captcha-botton"> {{$t('Click Refresh Verification Code')}}</button>                     -->
        </div>
        </div>
    </div>
</template>

<script>
import { joinUser, getCountries, recordClick,getImgCode } from '../api';
import { loadingData } from '../utils';
import { setStore, keys } from '../store';
import i18n from '../locales/i18n';
export default {
    data() {
        /* var checkPhone = (rule, value, callback) => {
            const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
            if (this.formLabelAlign.country_code == '') {
                return callback(new Error('区号不能为空'));
            }
            if (!value) {
                return callback(new Error('电话号码不能为空'));
            }
            setTimeout(() => {
                // Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
                // 所以在前面加了一个+实现隐式转换

                if (!Number.isInteger(+value)) {
                    callback(new Error('请输入数字值'));
                } else {
                    if (phoneReg.test(value)) {
                        callback();
                    } else {
                        callback(new Error('电话号码格式不正确'));
                    }
                }
            }, 100);
        }; */
        var checkEmail = (rule, value, callback) => {
            const mailReg = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/;
            if (!value) {
                return callback(new Error('邮箱不能为空'));
            }
            setTimeout(() => {
                if (mailReg.test(value)) {
                    callback();
                } else {
                    callback(new Error('请输入正确的邮箱格式'));
                }
            }, 100);
        };

        return {
            formLabelAlign: {
                child_nickname: '',
                mobile: '',
                email: '',
                wechat_id: '',
                country_code: '',
                code:''
            },
            comment: {
                index: 0,
                count: 4,
            },
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    { min: 10, message: '手机号码格式不对', trigger: 'blur' },
                ],
                email: [{required: true, validator: checkEmail, trigger: 'blur' }],
            },
            countries: [],
            max:10,
            btnFlag:false,
            flag:'',
            dialogVisible: false,
            input:'',
            screenWidth:'',
            messagecode:false
        };
    },
    mounted() {
        loadingData(async () => {
            let result = await getCountries({});
            this.countries = result.map((item) => {
                return { id: item.id, zh:item.name_zh, name: '+'+item.country_code+' '+item.name_zh, country_code: item.country_code ,name_zh : item.name_zh,flag:item.flag};
            });
            // this.formLabelAlign.country_code = this.countries[0].id
            // this.formLabelAlign.code = this.countries[0].country_code
        });
        var that=this
         that.screenWidth  =document.body.clientWidth ||window.screenWidth;
        window.addEventListener("resize", function() {
                        return(() => {
                         that.screenWidth  =document.body.clientWidth ||window.screenWidth;
                            //  console.log(that.screenWidth)
                        })();
                    });
        window.addEventListener("scroll", this.handleScroll);

        var tag="<span>"+this.formLabelAlign.code+"</span> ";
        var img="<img >"
        this.$refs['select'].$el.children[0].children[0].insertAdjacentHTML("beforeBegin",img);
              this.$refs['select'].$el.children[0].children[0].setAttribute(
            'style',
            'display:none;'
          )
        this.$refs['select'].$el.children[0].children[2].children[0].insertAdjacentHTML("beforeBegin",tag);
        //生成验证码---------------
        var self = this;
		    var options = {
		      element: this.$refs.captcha,
		      captchaId: "2e3422055bf14588a401899f1d8b25b6",
		      width: "320px",
              mode: 'embed',
              apiVersion: 2,
               lang :i18n.locale=='en'?'en':'zh-CN',
              onVerify:(err,data)=>{   //验证之后的回调函数,err验证失败才有值
                   if (err){
                    this.input=''
                    return
                  }
                  if(data){
                      this.input=data.validate
                      this.dialogVisible=false
                      this.submit('ruleForm')
                      self.instance && self.instance.refresh();
                    //    console.log(data.validate)
                  }
              }
		    };
		    initNECaptcha(options, function onLoad(instance) { //初始化成功
		    //   console.log(instance);
		      self.instance = instance;
		    },
            function onerror (err) { //初始化失败
                console.log(err)
            }
            );
		    this.$refs.popups.addEventListener("click", function() {
		      self.instance && self.instance.refresh();
		    });
            //-----------

    },
    computed: {
        ispc() {
            return window.innerWidth > 768 ? true : false;
        },
    },
    watch: {
        ispc(val) {
            window.onload();
        },
    },
    methods: {
        handleScroll(){
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 850) {
              this.btnFlag = true
            } else {
               this.btnFlag = false
            }
        },
      changeCode(){
        this.countries.map((item) => {
            if(this.formLabelAlign.country_code == item.id){
                this.formLabelAlign.code = item.country_code
                 this.flag=item.flag
            }
        });
        if(this.formLabelAlign.code=='86'){
            if(this.formLabelAlign.mobile.length>11){
                this.formLabelAlign.mobile = ''
            }
          this.max = 11
        //   this.rules.mobile[1].min=1
        }else if(this.formLabelAlign.code=='1'){
          if(this.formLabelAlign.mobile.length>10){
            this.formLabelAlign.mobile = ''
          }
          this.max = 10
        //   this.rules.mobile[1].min=1
        }
        else{
            this.max=15
            // this.rules.mobile[1].min=6
        }
         this.$refs['select'].$el.children[0].children[1].setAttribute(
            'style',
            // 'background:url('+ this.flag +') no-repeat;background-size: 21px 15px;background-position: 12px 13px;padding: 0 52px  0   49px; color: #111827;font-family: "Inter";font-weight: 500;font-size: 14px;'
            'padding: 0 0px 0 40px;'
          )
        this.$refs['select'].$el.children[0].children[0].src=this.flag;
        this.$refs['select'].$el.children[0].children[0].setAttribute(
            'style',
            'display:block;'
          )
          this.$refs['select'].$el.children[0].children[2].children[0].innerHTML="+"+this.formLabelAlign.code;
      },
      //关闭弹窗
            closebg(){
        this.dialogVisible=false
        },
        //
        async submit(ruleForm) {
            await loadingData(async () => {
                try {
                    let form = {
                        mobile: this.formLabelAlign.mobile,
                        email: this.formLabelAlign.email,
                        country_code: this.formLabelAlign.code,
                        child_nickname: this.formLabelAlign.child_nickname,
                        wechat_id: this.formLabelAlign.wechat_id,
                        landingpage_id: 11,
                        captcha:this.input,
                        ...this.$route.query,

                    };

                    this.$refs[ruleForm].validate(async (valid) => {
                        if (valid) {
                            if(!this.formLabelAlign.country_code){
                                alert(i18n.t('Please select your country code'))
                                return false
                            }
                            if(this.input==''){
                                this.dialogVisible=true
                                return
                            }else{
                                this.input=''
                            let userInfo = await joinUser(form);

                            setStore(keys.userInfo, userInfo);
                            // if (userInfo.is_register){
                            // await recordClick(2,userInfo.user_sn);
                            // }

                            await recordClick(1, userInfo.user_sn, 'landingpage-id:11');
                            if (userInfo.name) this.$router.push({ path: '/salecard',query:{invite_code:userInfo.invite_code} });
                            // setTimeout(() => {
                            //     if (userInfo.name) this.$router.push({ path: '/salecard',query:{invite_code:userInfo.invite_code} });
                            // }, 1000);
                            }
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                } catch (error) {
                    this.status = false;
                }
            });
        },
        commentClick(value) {
            console.log(value);
            let nextIndex = this.comment.index + value;
            if (nextIndex < 0) return;
            if (nextIndex + 3 > this.comment.count) return;

            this.$refs.overContainer.scrollLeft = nextIndex * 330;
            this.comment.index = nextIndex;
        },

        toTop() {
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                if (top <= 200) {
                    clearInterval(timeTop);
                }
            }, 10);
            // document.body.scrollTop = document.documentElement.scrollTop =150;
        },
    },
    components: {},
};
</script>

<style scoped lang='less'>
//弹窗样式--------------
.captcha-botton{
  width: 90%;
  height: 40px;
   border-radius:6px;
   cursor: pointer;
       background-color: #409eff;
    border-color: #409eff;
    color: #fff;
    border: none;
}
//图片滑动验证码样式
.show-captcha{
   position: fixed;
   display: flex;
   justify-content:center;
   align-items:center;
   top: 0%;
   left: 0%;
   right: 0;
   bottom: 0;
   background-color: rgba(0, 0, 0, 0.3);
   z-index: 99999999999;
   .show-captcha-div{
       display: flex;
       justify-content : center;
       align-items:center;
       flex-direction:column;
       width: 350px;
       height: 350px;
       background: #fff;
       padding: 5px 5px;
       position: relative;
       div{
         text-align: center;
         box-sizing: border-box;
       }
       button{
          //  position: absolute;
          //  bottom: 10px;
           width: 80%;
           margin-top: 20px;
          //  left: 10%;
       }

   }
}
//-------------
/deep/.el-select .el-input {
    img{
        width: 17px;
        position: absolute;
        left: 12px;
        bottom: 18px;
    }
}

.selectoption{
        width: 280px;
        display: flex;
        justify-content:space-between;
        img{
            width: 15px;
            margin-right: 16px;
        }
        span{
            display: flex;
            align-items: center;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;

            color: #111827;
        }
    }

/deep/.el-select .el-input .el-input__icon{
    width: 7px;
    font-size: 9px;
    padding-right: 7px;
}
    /deep/.el-input__suffix{
        display: flex;
        align-items:center;
        margin: auto;
        span:nth-child(1){
            display: block;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            margin: auto;
            padding-left: 5px;
            color: #111827;
            // width: 30px;
                }

    }
body {
    overflow-x: hidden;
    box-sizing: border-box;
    font-family: 'Muli';
}
h1,h3 {
    margin: 0;
    font-weight: normal;
}
@media screen and (min-width: 768px) {
    .centerimg{
        display: flex;
        width: 300px;
        margin: 20px auto;
        // position: relative;
        .cenimgone{
            width: 120px;
            margin: 10px auto;
            position: relative;
            height: 100px;
            .topimg{
                position: absolute;
                left: 15px;
                top: 90px;
            }
            span{

               display: block;
               margin-top: 30px;
               font-family: 'Sofia Pro';
                font-style: normal;
                font-weight: 500;
                font-size: 20px;
                line-height: 20px;
            }

        }
    }
    .musk{
         position: absolute;
            top: 0;
            left: 0;

            right: 0;
            bottom: 0;
            display: flex;

            background: rgba(0, 78, 146, 0.57);
    }
    .interbox{
       cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #ffd300;
      border-radius: 25px;
      position: fixed;
      bottom: 72px;
     height: 48px;
     width: 573px;
     z-index: 9999999;
     left: calc(50% - 573px/2);;
      color: #000000;

    font-style: normal;
     font-weight: 700;
     font-family: MuliBold;
    font-size: 18px;
    line-height: 28px;
    filter: drop-shadow(0px 4px 26.64px rgba(0, 0, 0, 0.25));
  }
  .row{
    height:100%;
  }
  .container {
    font-size: 14px;
    font-family: 'Muli';
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
    header {
      display: block;
        box-sizing: border-box;
        height: 88px;
        > div {
            span {
                font-family: MuliSemiBold;
                margin-left: 24px;
                a{
                  font-size: 16px;
                  color: #111827;

                }
            }
        }
    }

    section {
        position: relative;

        box-sizing: border-box;

        background: url('../assets/img/Rectangle.png') no-repeat;

        background-size: cover;
        height: 947px;
        .mask {
            position: absolute;
            top: 0;
            left: 0;

            right: 0;
            bottom: 0;
            display: flex;

            background: rgba(0, 78, 146, 0.57);
        }
           .rightBTM{
                 background: url('../assets/img/Ellipsetop.png') no-repeat;
                position: absolute;
                top: 0;
                right: 0;
                width: 250px;
                height: 176px;
           }
            .leftBTM {
                background: url('../assets/img/Ellipse.png') no-repeat;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 474px;
                height: 350px;
                // div {
                //     background: url('../assets/img/Ellipse2.png') no-repeat;
                //     position: absolute;
                //     bottom: 0;
                //     left: 0;
                //     width: 241px;
                //     height: 229px;
                // }
            }
            .left {
                flex:4;
                div:nth-child(1) {
                    width:  100%;

                    // padding: 241px 0 0 10%;
                    h1 {
                        width:  100%;
                        font-size: 72px;
                        color: white;
                        text-align: center;
                        letter-spacing: -0.02em;
                        font-family: MuliBold;
                    }
                }

                div:nth-child(2) {
                    margin-top:60px;
                    border-radius: 29px;
                    background-color: white;
                    width: 550px;
                    height: 43px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-left: 65px;
                    span {
                        color: #0085F2;
                        font-size: 24px;
                       font-family: 'MuliSemiBold';
                        font-weight: 700;
                        line-height: 1.2;
                    }
                }
            }
            .right {
                flex: 3;
                // margin-left: 5%;
                display: flex;
                flex-direction: column;
                align-items: center;
                img {
                    margin-top: 88px;
                }
                .forms_submit {
                    width: 407px;
                    height: 490px;
                    background: #FFFFFF;
                    box-shadow: 0px 10px 15px -3px rgba(16, 24, 40, 0.1), 0px 4px 6px -4px rgba(16, 24, 40, 0.1);
                    border-radius: 12px;
                    padding: 24px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    margin: -50px auto 0;
                    /deep/ .el-form-item {
                        // .el-form-item__content{
                        //     .el-input{
                        //         /deep/.el-input__inner:focus{
                        //             border:1px solid hsl(0, 0%, 0%);

                        //     }

                        //     }
                        //     .el-input.is-active .el-input__inner, .el-input__inner:focus{
                        //         border:1px solid hsl(0, 0%, 0%);
                        //     }
                        // }
                        font-family: 'Muli';
                        margin-bottom: 15px;

                        .el-form-item__label{
                          font-size:14px;
                          color: #111827;
                          font-weight: 400;
                        }
                        .el-form-item__content{
                          line-height: 44px;
                          .el-input-group{

                            .el-input__inner{
                                    border-radius:0 6px 6px 0;
                                    font-family: 'Muli';
                            }
                            // /deep/.el-input__inner:focus{
                            //         border:1px solid hsl(0, 0%, 0%);
                            // }
                          }
                          .el-input-group__prepend{
                            background: none;
                            border:none;
                            .el-input__inner{
                                border-radius:6px 0 0 6px;
                                  font-family: 'Muli';
                            }
                            //  /deep/.el-input__inner:focus{
                            //         border:1px solid hsl(0, 0%, 0%);
                            // }
                          }
                          .el-input__inner{
                            height: 44px;

                              /* Neutral/300 */
                              border: 1px solid #D1D5DB;
                              box-sizing: border-box;
                              /* Drop shadow/XSmall */
                               font-family: 'Muli';
                              box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
                              border-radius: 6px;
                              margin: 4px 0px;
                               &::placeholder {
                                  color: #9CA3AF;
                                  font-size: 16px;
                                    font-family: 'Muli';
                              }
                            //    /deep/.el-input__inner:focus{
                            //         border:1px solid hsl(0, 0%, 0%);
                            // }
                          }
                        }
                    }
                    .toplog {
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                            letter-spacing: -0.02em;
                        h1 {
                            color: #0085F2;
                            font-size: 36px;
                            letter-spacing: -0.02em;
                            font-family: MuliBold;
                        }
                        .subTitle {
                            font-size: 24px;
                            letter-spacing: -0.02em;
                        }
                        .subBreif{
                          font-size: 18px;
                          display: block;
                          margin-top: 5px;


                        }
                    }
                    button {
                        width: 100%;
                        height: 48px;
                        border: none;
                        color: white;
                        background: #0085F2;
                        border-radius: 25px;
                        font-size: 18px;
                        font-family: 'YuanCuGBK';
                    }
                }
            }
    }

    .bodypink {
        background: #f7f5fa;
        padding: 139px 0 0 0;
        text-align: center;
        // position: relative;
        overflow: hidden;
        // .classover {
        //     width: 521px;
        //     display: flex;
        //     justify-content: space-between;
        //     // position: absolute;
        //     left: calc(50% - 260.5px);
        //     // top: 80px;
        //     /*  > div {
        //         position: absolute;
        //         left: 64px;
        //         right: 64px;
        //     } */
        //     /* > img:first-child {
        //         position: absolute;
        //         top: 34px;
        //         left: 0;
        //         width: 133px;
        //         height: 53px;
        //     }
        //     > img:last-child {
        //         position: absolute;
        //         top: 34px;
        //         right: 3px;
        //         width: 133px;
        //         height: 53px;
        //     } */
        // }
        // .title {
        //     /* margin-top: 139px; */
        //     width: 391px;
        //     height: 72px;
        //     /* background: #ff5979; */
        //     /*  border-radius: 4px; */
        //     /*  font-weight: 600;
        //     font-size: 32px; */
        //     /*  display: flex;
        //     justify-content: center; */
        //     color: white;
        //     /*  align-items: center; */
        //     text-align: center;
        // }
        .four {
            // padding-left: 20%;
            width: 100%;
            margin: 0 auto;
            // border: 4px solid #ff5979;
            box-sizing: border-box;
            border-radius: 16px;
            height: 800px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            position: relative;

            img{
              position: absolute;
              top:-65px;
              left:50%;
              margin-left:-260px;
            z-index:21;
            }
            .title-1{
              position: absolute;
              top:-55px;
              left:50%;
              margin-left:-111px;
                z-index:22;
                font-size: 32px;
                color: #FFFFFF;
             font-family: MuliSemiBold;
             font-weight: 600;
            }
            .flexsum{
                display: flex;
                margin-top: 60px;
            }
            .flex-line{

                    justify-content: space-around;
                    align-items: center;
                    width: 400px;
                    margin: 0px 30px;
                    margin-top: 78px;
                    flex-direction: column;
                    justify-content: start;
                    align-items: flex-start;
                    img{
                        position: static;
                        margin: 0px;
                    }
                    span {
                        display: block;
                        font-style: normal;

                        text-align: center;
                        margin: 0px auto;
                    }

                    span:first-child,.onpan {
                        color: #0085F2;
                        font-weight: 700;
                        font-size: 30px;
                        line-height: 48px;
                        width: 300px;
                        height: 100px;
                        margin-bottom: 20px;
                        font-family: MuliBold;

                    }

                    span:last-child,.twospan {
                        font-weight: 400;
                        font-size: 20px;
                        line-height: 36px;
                        width: 379px;
                        height: 196px;

                    }
                    .twospan{
                        width: 388px;
                    }

                    .onpan{
                    //    width: 0px;
                    //    height: 0px;
                       display: inline-block;
                       margin: 0px;
                   }

            }
                .threespan{
                span:last-child{
                     width: 362px;
                }

            }

            > div:nth-child(odd) {
            }
        }

         .titleen{
                position: absolute;
                top:-45px;
                 left:5%;
                  z-index:9999;
                  display: flex;
                  width: 300px;
                  height: 50px;
                  img{
                      margin: 0px;
                      padding: 0px;
                       position: absolute;
                       top: 0px;
                       width: 33px;
                       height: 33px;
                  }
                  .img1{
                       left: 80px;
                       z-index: 99999;
                  }
                  .img2{
                      left: 140px;
                  }
                   .img3{
                      left: 200px;
                  }
            }
            .titleen2{
                position: absolute;
                top:30px;
                 left:5%;
                  z-index:9999;
                  display: flex;
                  width: 300px;
                  height: 50px;
                  img{
                      margin: 0px;
                      padding: 0px;
                       position: absolute;
                       top: 0px;
                       width: 33px;
                       height: 33px;
                  }
                  .img1{
                       left: 80px;
                       z-index: 99999;
                  }
                  .img2{
                      left: 140px;
                  }
                   .img4{
                      left: 200px;
                  }
            }
            .titleon{
                 position: absolute;
                top:-45px;
                 right:5%;
                  z-index:9999;
                  display: flex;
                  width: 300px;
                  height: 50px;
                  img{
                      margin: 0px;
                      padding: 0px;
                       position: absolute;
                       top: 0px;
                        width: 33px;
                       height: 33px;
                  }
                  .img1{
                       left: 80px;
                       z-index: 99999;
                  }
                  .img2{
                      left: 140px;
                  }
                   .img3{
                      left: 200px;
                  }
            }
            .titleon2{
                 position: absolute;
                top:30px;
                 right:5%;
                  z-index:9999;
                  display: flex;
                  width: 300px;
                  height: 50px;
                  img{
                      margin: 0px;
                      padding: 0px;
                       position: absolute;
                       top: 0px;
                        width: 33px;
                       height: 33px;
                  }
                  .img1{
                       left: 80px;
                       z-index: 99999;
                  }
                  .img2{
                      left: 140px;
                  }
                   .img4{
                      left: 200px;
                  }
            }
        .rowimg{
            position: relative;
            //  background: url('../assets/img/student.png') no-repeat;
             .imgsen{
                 top: 0px;
                 left: 0px;
                 position: absolute;

             }
        }

        .pinkTwo {
            width: 100%;
            // height: 899px;
            margin-top: 21px;
            position: relative;
            display: flex;
            // background: url('../assets/img/student.png') no-repeat;
            .two_tit {
                width : 992px ;
                height : 449px ;
                background : #FFFFFF ;
                margin: 0px auto;
               margin-top: 267px;
               margin-bottom: 67px;
                border-radius : 22px ;
                flex-direction: column;
                text-align: start;
                z-index: 9999;

                font-weight : 400 ;
                text-align : center ;
                span:nth-child(1) {
                    color : #0085F2 ;
                    width : 372px ;
                    height : 48px ;
                    font-size : 40px ;
                    line-height : 48px ;
                    display: block;
                    margin: 30px auto;
                    align-items : center ;
                    font-weight: 600;
                    font-family: MuliSemiBold;
                }
                span:nth-child(2) {
                    display: block;
                    font-size : 18px ;
                    line-height : 28px ;
                    color : #374151 ;
                    margin: 0px auto;
                    margin-top: 24px;
                    width : 598px ;
                    height : 28px ;
                }
                .spanclass{
                    width : 498px ;
                    height : 28px ;
                    margin: 0px auto;
                  margin-top:87px;
                    font-size: 18px;
                    color: #374151;
                    line-height: 28px;
                    display: block;
                }
            }
            .tabs{
              display: none;
            }
            .piclist {
              flex:1;
                  margin-right: -135px;
                display: flex;
                flex-wrap: wrap;
                /*   justify-content: flex-end; */
                /* margin-left: 60px; */
                > div {
                    margin: 0 0 48px 65px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    position: relative;
                    span {
                        margin-top: 20px;
                        font-family: 'YuanZhunGBK';
                    }
                }

                div:nth-child(5),
                div:nth-child(10),
                div:nth-child(15) {
                    margin-right: 0px;
                }
            }
        }
    }

    .bodyred {
      position: relative;
      height: 600px;
      .img1{
        width:470px;
        height:540px;
        position: absolute;
        top:0;
        left:0;
        z-index:10;
      }
      .img2{
        width:273px;
        height:362px;
        position: absolute;
        top:0;
        left:0;
        z-index:11;
      }
      .img3{
        width:430px;
        height:910px;
        position: absolute;
        bottom:0;
        right:0;
        z-index:11;
      }
    }

    .youshiBox{
        width:100%;
        height: 100%;
        z-index:13;
        .title-2 p{
            position: absolute;
            top: -24px;
            left: 50%;
            margin-left: -111px;
            z-index: 13;
            font-size: 32px;
           color: #000000;
           font-weight: 600;
           font-family: MuliSemiBold;
        }
        .THRbox {
            margin-top: 84px;
            display: flex;
            justify-content: center;
            .whitebox {
                // margin: 0 20px;
                width: 384px;
                height:92px;
                flex:1;
                margin-right:32px;
                background: #FFFFFF;
                /* Drop shadow/Small */

                box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px -1px rgba(16, 24, 40, 0.1);
                border-radius: 6px;
                padding-bottom: 20px;

                // width: 30vw;
                /*  width: 384px; */
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                span:first-child {
                    color : #0085F2 ;
                    font-size: 28px;
                    font-weight: 700;
                    font-family: MuliBold;
                }
                span {
                    font-size: 20px;
                    color: #6B7280;


                }
            }
        }
    }

    .jiangpai {
        position: absolute;
        background: url('../assets/img/Framejiangpai.png') no-repeat;
        top: 420px;
        left: 0;
        width: 113px;
        height: 140px;
        display: block;
    }

    .iphone {
        /* margin: 0 auto; */

        /* width: 943.36px;
        height: 484.3px; */
        width: 942px;
        height: 484px;
        border-radius: 47px;
        background-color: #fff;
        transform: rotate(-10.16deg);
        margin-top: 60px;
        background: #FFFFFF;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);

        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin:184px auto 0;
        img {
            /*  position: absolute; */
            width: 900px;
            // height: 402.09px;
            // margin-top: 1vh;
            /*  width: 90%;
            height: 90%; */
            /*  left: 13px;
            top: -38px; */
            transform: rotate(10.16deg);
            /* transform: rotate(10.16deg); */
        }
    }

    .guide {
        position: absolute;
        /*  background: url('../assets/img/Groupguird.png') no-repeat; */
        top: 850px;
        z-index: 13;
        // left: 100%;
        right: 0px;
        width: 315.97px;
        height: 311.54px;

    }

    .appCircleRIG{
      display: none;
    }
    .bgWhite {
      background: #F7F5FA;
      .whiteBg{
        display: block;
        position: relative;
        .cerebrumAPP {
            z-index: 1;
            position: absolute;
            background: url('../assets/img/Framecere.png') no-repeat;
            top: -75px;
            right: 249px;
            width: 126px;
            height: 123px;
        }
        > img {
            margin: 50px auto 30px;
        }
      }
        background: #f7f5fa;
        text-align: center;
        /*    padding-bottom: 185px; */
        #mien {
            padding: 120px 0 90px 0;
            font-size: 32px;
            font-weight: 700;
            font-family: MuliBold;
        }
        .videoStyle {
            width: 100%;

            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            > div {
                flex-basis: 40vw;
                min-height: 200px;
                background-color: #fff;
                margin-bottom: 36px;
            }
        }

		.video_box{
			display: flex;
			flex-wrap:wrap;
      justify-content: space-evenly;
			.video_info{
				height: 251px;
				width: 570px;
				// margin-right: 60px;
				margin-bottom:60px;
				&:nth-child(2n){
					margin-right:0;
				}
			}
		}
        .swiperfor {
            margin-top: 130px;
            text-align: center;
            margin-bottom:60px;
            > div:nth-child(1) {
                font-size: 14px;
                color: #0085F2;
                font-weight: 700;
                font-family: MuliBold;
            }
            > div:nth-child(2) {
                font-size: 40px;
                color: #111827;
                margin-top:16px;
                font-weight: 700;
                font-family: MuliBold;
            }
        }
        .btn_lq {
            width: 410px;
            height: 47px;
            border-radius: 37px;
            background: #ff5979;
            color: white;
            margin: 70px auto 0;
            font-size: 18px;
            justify-content: center;
            align-items: center;
            display: flex;
        }
    }
    .star-item {
        width: 210px;
    }
    .star-list {
        .over-list {
            overflow: hidden;
            width: 820px;
            white-space: nowrap;
            scroll-behavior: smooth;
            .arrow-left,.allow-right{}
            > .star-item {
                display: inline-block !important;
                vertical-align: top;
                white-space: normal;
                margin-left: 30px !important;
                margin-right: 30px !important;

                > * {
                    display: block;
                }
                .star-desc{
                    font-family: 'Poppins';
                    color: #0B1D33;
                }
                .star-sub{
                    color: rgba(11, 29, 51, 0.6);
                }
            }
        }
    }
    .star-left {
        width: 190px;
        span{
            font-family: 'Poppins';
            font-weight: 400;
        }
    }
    .star-container {
        // margin-left: 10vw;
        // width: 70vw;
        width: 1010px;
         display: flex;
         margin: 0 auto;
         padding-bottom: 100px;
        justify-content: center;
        .star-left {
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;

            label {
                font-size: 21.654px;
                line-height: 100%;

                text-align: center;

                color: #000000;
            }

            .star-img-big {
                width: 190.07px;
                height: 39.7px;
            }
        }
         .start-content{
             display: flex;
             margin-left:60px;
             .info-feed{

                box-shadow: 12px 8px 33px rgba(0, 0, 0, 8%);
                height: 179px;
                width: 201px;
                padding: 19px 13px;
                margin-right:40px;
                &:nth-child(3){
                    margin-right: 0;
                }
                h6 {
                    color: #000;
                    // display: block;
                    // width: 183px;
                    font-size: 20px;
                    z-index: 100040;
                    line-height: 1.1;
                    letter-spacing: 0;
                    text-align: left;
                    text-align-last: left;
                    font-style: normal;
                    display: block;
                    margin: 0 11px;
                    margin-bottom: 13px;
                    font-family: "times new roman";
                    font-weight: bold;
                }
                p {
                    color: #000;
                    display: block;
                    // width: 177px;
                    font-size: 14px;
                    line-height: 1.4;
                    letter-spacing: 0;
                    font-style: normal;
                    text-align: left;
                    text-align-last: left;
                    margin: 0 8px;
                    font-family: "open sans";
                }
                img {
                    height: 29px;
                    width: 169px;
                    margin-bottom: 6px;
                }
             }
         }
    }
    footer {
       background: #1068AF;

        height: 664px;
        text-align: center;
        position: relative;
        .img1{
            width:340px;
            height:385px;
            position: absolute;
            top:0;
            right:0;
            z-index:10;
        }
        .img2{
            width:155px;
            height:198px;
            position: absolute;
            top:0;
            right:0;
            z-index:11;
        }
        .img_m3,.img_m4{
          display: none;
        }
        .footer_box{
            width:100%;
            position: inherit;

           h3{
               font-size: 14px;
               color: #FFFFFF;
           }
           h1{

                font-size: 36px;
                line-height: 44px;
                text-align: center;
                letter-spacing: -0.02em;

                color: #FECE0C;
           }
            .aboutus {
                margin-top: 20px;
                display: block;
                color: #fece0c;
                position: inherit;
                font-size: 36px;
                font-weight: 700;
                font-family: MuliBold;
            }
            .londtitle {
                width: 667px;
                margin: 25px auto 0;
                white-space: normal;
                word-break: break-word;
                // word-wrap: break-word;
                color: white;
                font-size: 18px;
                line-height: 44px;
                z-index: 100;
                position: inherit;

            }
            .btn_yellow {
                width: 410px;
                height: 48px;
                background: #fece0c;
                margin: 40px auto 0;
                border-radius: 25px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                color:#333;
            }
        }
        .fooimg1 {
            position: absolute;
            top: 147px;
            left: 10%;
            display: block;
        }
        .fooimg2 {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 345px;
            height: 441px;
        }
        .fooimg3 {
            position: absolute;
            right:0;
            bottom: -30px;
        }
        .circleRightTop {
            position: absolute;
            /* width: 473px;
            height: 519px; */
            width: 30vw;
            height: 30vw;
            top: 0;
            right: 0;
            img:first-child {
                position: absolute;
                top: 0;
                right: 0;
                width: 80%;
                height: 80%;
            }
            img:last-child {
                position: absolute;
                top: 0;
                right: 0;
                width: 60%;
                height: 60%;
            }
        }
    }
}
@media screen and (max-width: 767px) {
    //验证码插件弹图位置
    /deep/ .yidun_intellisense--light .yidun_classic-container{
       bottom: 0;
       top: auto;
    }
   /deep/ .yidun_popup.yidun_popup--light .yidun_modal{
       bottom: 0;
       top: auto;
       left: 0;
       width: 100%;
       position: absolute;
    }
//--------------------------------------------
     /deep/ .el-scrollbar{
        min-width: 320px;
    }
    .musk{
        position: absolute;
            top: 0;
            left: 0;

            right: 0;
            bottom: 0;
           background: rgba(0, 78, 146, 0.57);
    }
  .interbox{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
     background-color: #ffd300;
      border-radius: 25px;
      position: fixed;
      bottom: 56px;
     height: 48px;
     width: 376px;
     z-index: 9999999;
     left: calc(50% - 376px/2);
    color: #000000;

    font-style: normal;
     font-weight: 700;
     font-family: MuliBold;
    font-size: 18px;
    line-height: 28px;
    filter: drop-shadow(0px 4px 26.64px rgba(0, 0, 0, 0.25));
  }
  .row{
    height:100%;
  }
  .container {
    font-size: 14px;
   font-family: Muli;
    width: 100vw;
    height: 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
    header{
        display: none;
    }
    section {
        width: 100vw;
        position: relative;
        display: flex;
        flex-direction: column;
        // align-items: center;

        box-sizing: border-box;

        background: url('../assets/img/Rectangleapp.png') no-repeat;

        background-size: cover;
        // height: 988px;
        // padding: 0px 50px;
        padding-bottom: 37px;

        .mask {
            position: absolute;
            top: 0;
            left: 0;

            right: 0;
            bottom: 0;
           background: rgba(0, 78, 146, 0.57);
        }
            .rightBTM{
                    background: url('../assets/img/Ellipsetop.png') no-repeat;
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 114px;
                    height: 151px;
            }
            .leftBTM {
                background: url('../assets/img/Ellipse.png') no-repeat;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100vw;
                height: 201px;
                background-size: cover;
            }

            .left {

                width: 360px;


                div:nth-child(1) {
                  // position: absolute;
                    //  top: 91px;
                    // display: flex;
                    // width: 362px;
                    // height: 75px;
                    // margin: 0px auto;
                    // justify-content: center;
                    // flex-direction: column;
                    margin-bottom:30px;
                    margin-top:50px;
                    h1 {
                        text-align: center;
                        font-size: 46px;
                        color: white;
                        line-height: 50px;
                        letter-spacing: -0.03em;
                        font-family: MuliBold;
                    }
                }

                div:nth-child(2) {
                    // position: absolute;
                    border-radius: 29px;
                    background-color: white;
                    // top: 205px;
                    width: 300px;
                    height: 43px;
                    line-height:43px;
                    text-align: center;
                    margin:0 auto 41px;
                    span {
                        font-size: 18px;
                        color: #0085F2;
                        font-family: MuliSemiBold;
                    }
                }
            }
            .right {
                /*  padding: 1px; */
                margin-top: 70px;
                display: flex;
                flex-direction: column;
                align-items: center;
                // top: 100px;
                // position: relative;
                // left: 0px;
                .forms_submit {
                  // position: absolute;
                  // top:-50px;
                    /deep/.el-form{
                      margin-top:10px;
                      .el-form-item {
                        font-family: 'Muli';
                        margin-bottom: 18px;
                         .el-form-item__content{
                            // .el-input{
                            //     /deep/.el-input__inner:focus{
                            //         border:1px solid hsl(0, 0%, 0%);
                            // }
                            // }

                            // .el-input.is-active .el-input__inner, .el-input__inner:focus{
                            //     border:1px solid hsl(0, 0%, 0%);
                            // }
                        }
                        .el-form-item__label{
                          font-size:14px;
                          color: #111827;
                        }
                        .el-form-item__content{
                          line-height: 44px;
                          .el-input-group{
                            .el-input__inner{
                                    border-radius:0 6px 6px 0;
                                      font-family: 'Muli';
                            }
                            //  /deep/.el-input__inner:focus{
                            //         border:1px solid hsl(0, 0%, 0%);
                            // }
                          }
                          .el-input-group__prepend{
                            background: none;
                            border:none;
                            .el-input__inner{
                                border-radius:6px 0 0 6px;
                                  font-family: 'Muli';
                            }
                            //  /deep/.el-input__inner:focus{
                            //         border:1px solid hsl(0, 0%, 0%);
                            // }
                          }
                          .el-input__inner{
                            height: 44px;

                              /* Neutral/300 */

                              border: 1px solid #D1D5DB;
                              box-sizing: border-box;
                              /* Drop shadow/XSmall */

                              box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
                              border-radius: 6px;
                              margin: 4px 0px 0;
                               font-family: 'Muli';
                               &::placeholder {
                                  color: #9CA3AF;
                                  font-size: 16px;
                                  font-family: 'Muli';
                              }
                            //    /deep/.el-input__inner:focus{
                            //         border:1px solid hsl(0, 0%, 0%);
                            // }
                          }
                        }
                      }

                    }
                    /*      max-height: 506px; */
                    z-index: 1;
                    // position: relative;
                    margin: -50px auto 0;

                    box-sizing: border-box;
                    width: 360px;
                    box-shadow: 0px 10px 15px -3px rgba(16, 24, 40, 0.1), 0px 4px 6px -4px rgba(16, 24, 40, 0.1);
                    /*  width: calc(100vw - 44px); */
                    border-radius: 12px;
                    background-color: #fff;
                    padding: 24px 11px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;

                    .toplog {
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                            letter-spacing: -0.02em;
                        h1 {
                            color: #0085F2;
                            font-size: 36px;
                            letter-spacing: -0.02em;
                            margin-bottom:10px;
                            font-family: MuliBold;
                        }
                        .subTitle {
                            font-size: 24px;
                            letter-spacing: -0.02em;
                        }
                        .subBreif{
                          font-size: 14px;
                          display: block;
                          margin-top: 10px;
                          color: #374151;

                        }
                    }
                    button {
                        width: 100%;
                        height: 48px;
                        border: none;
                        color: white;
                       background: #0085F2;
                        border-radius: 25px;
                        font-size: 18px;
                        font-family: 'MuliBold';
                    }
                }
            }

        // .bgred {
        //     height: 200px;
        //     position: absolute;
        //     bottom: 0;
        //     left: 0;
        //     right: 0;
        //     background: url('../assets/img/Vector.png');
        // }
    }
    .bodypink {
        background: #f7f5fa;
        padding: 60px 0 0 0;
        width:100vw;
        position: relative;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        // .classover {
        //     margin: 0 auto;
        //     position: absolute;
        //     top: -15px;
            /* position: inherit; */

            /*  > div {
                width: 70%;
                height: 56.08px;
                position: absolute;
                top: 72px;
                left: calc(50vw - 35%);
                right: 96px;
            }
            img:first-child {
                position: absolute;
                top: 100px;
                left: 7%;
                width: 83px;
                height: 39px;
            }
            img:last-child {
                position: absolute;
                top: 100px;
                right: 6%;
                width: 83px;
                height: 39px;
            } */
        // }
        // .title {
        //     margin-top: 60px;
        //     width: 70%;
        //     height: 72px;
        //     /* background: #ff5979; */
        //     /* border-radius: 4px; */
        //     /*  font-weight: 600;
        //     font-size: 20px;
        //     display: flex;
        //     justify-content: center;
        //     color: white;
        //     align-items: center;*/
        //     text-align: center;

        //     margin-left: 15%;
        //     img {
        //         width: 100%;
        //     }
        // }
        .four {
            width: 360px;
            margin: 0 auto;

            box-sizing: border-box;
            border-radius: 16px;
            // height: 239px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            position: relative;
            margin-top:50px;
            img{
              position: absolute;
              top:-48px;
              left:50%;
              margin-left:-125px;
              z-index:21;
              width: 250px;
              height: 67.85px;
            }

            .title-1{
              position: absolute;
              top:-38px;
              left:50%;
              margin-left:-70px;
                z-index:22;
                font-size: 20px;
                color: #FFFFFF;
               font-family: MuliSemiBold;
             font-weight: 600;
            }
            .flexsum{
                margin-top: 80px;
            }
            .flex-line{

                    justify-content: space-around;
                    align-items: center;
                    width:100%;

                    flex-direction: column;
                    justify-content: start;
                    align-items: flex-start;
                    img{
                        position: static;
                        width : 322px ;
                        height : 322px ;
                        margin: 0px;
                    }
                    div{
                         margin: 33px auto;
                        width : 322px ;
                        height : 322px ;
                         margin-bottom: 60px;
                    }

                    span {
                        display: block;
                        font-style: normal;
                        font-size: 22px;
                        text-align: center;
                        margin: 0px auto;
                    }
                    span:first-child {
                        color: #0085F2;
                        margin-bottom:30px;
                        width: 313px;

                        font-weight: 700;
                        font-size: 30px;
                        line-height: 45px;
                        font-family: MuliBold;
                    }
                    span:last-child,.twospan {
                        font-size: 20px;
                        line-height: 36px;
                        margin-bottom: 80px;
                        width: 334px;
                    }
                    .twospan{
                         margin-bottom: 30px;
                    }

                    .onpan{
                        // display: inline-block;
                        margin: 0px;
                    }

            }
            .threespan{
                span:last-child{
                     width: 345px;
                }

            }
            > div:nth-child(odd) {
            }
            // margin: 47px 4%;
            // border: 1px solid #ff5979;
            // box-sizing: border-box;
            // border-radius: 16px;
            // height: 240px;
            // display: flex;
            // flex-wrap: wrap;

            // /*  padding: 0 25px; */
            // justify-content: space-around;
            // > div {
            //     width: 40%;
            //     height: 50px;
            //     display: flex;
            //     flex-direction: column;

            //     text-align: start;
            //     span {
            //         font-style: normal;
            //         font-size: 18px;
            //     }
            //     span:first-child {
            //         color: #ff5979;
            //     }
            //     span:last-child {
            //     }
            // }
            // > div:nth-child(1),
            // > div:nth-child(2) {
            //     margin-top: 58px;
            // }
        }
        .titleen{
                position: absolute;
                top:-10px;
                 left:0px;
                  z-index:9999;
                  display: flex;
                  width: 80px;
                  height: 20px;
                  img{
                      margin: 0px;
                      padding: 0px;
                       position: absolute;
                       top: 0px;
                       width: 8.71px;
                        height: 8.71px;
                  }
                  .img1{
                       left:5px;
                       z-index: 99999;
                  }
                  .img2{
                      left: 20px;
                  }
                   .img3{
                      left: 40px;
                  }
            }
            .titleon{
                 position: absolute;
                top:-10px;
                 right: 0px;
                  z-index:9999;
                  display: flex;
                  width: 60px;
                  height: 20px;
                  img{
                      margin: 0px;
                      padding: 0px;
                       position: absolute;
                       top: 0px;
                       width: 8.71px;
                        height: 8.71px;
                  }
                  .img1{
                       left: 5px;
                       z-index: 99999;
                  }
                  .img2{
                      left: 20px;
                  }
                   .img3{
                      left: 40px;
                  }
            }
            .titleon2{
                 position: absolute;
                top:40px;
                 right: 0px;
                  z-index:9999;
                  display: flex;
                  width: 50px;
                  height: 20px;
                  img{
                      margin: 0px;
                      padding: 0px;
                       position: absolute;
                       top: 0px;
                       width: 8.71px;
                        height: 8.71px;
                  }
                  .img1{
                       left: 5px;
                       z-index: 99999;
                  }
                  .img2{
                      left: 20px;
                  }
                   .img4{
                      left: 40px;
                  }
            }
        .titleen2{
            position: absolute;
                top:40px;
                 left:0px;
                  z-index:9999;
                  display: flex;
                  width: 80px;
                  height: 20px;
                  img{
                      margin: 0px;
                      padding: 0px;
                       position: absolute;
                       top: 0px;
                       width: 8.71px;
                        height: 8.71px;
                  }
                  .img1{
                       left:5px;
                       z-index: 99999;
                  }
                  .img2{
                      left: 20px;
                  }
                   .img4{
                      left: 30px;
                  }

        }
        .pinkTwo {
        //   width:360px;

            .two_tit {
                margin-top: 449px;
                margin-bottom: 60px;
                width: 380px;
                display: flex;
                flex-direction: column;
                align-items: center;
                 text-align: center;
                 background: #FFFFFF;
                box-shadow: 0px 4px 28px rgba(0, 0, 0, 0.25);
                border-radius: 15px;
                span:nth-child(1) {
                    margin-top: 40px;
                    font-size: 36px;
                   color: #0085F2;
                    margin-bottom:15px;
                    font-weight: 600;
                    font-size: 30px;
                    line-height: 48px;
                    font-family: MuliSemiBold;
                }
                span:nth-child(2) {
                    width: 340px;
                    height: 56px;
                    color: #374151;
                    margin-bottom:45px;
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 28px;

                }
               .spanclass{
                    width : 300px ;
                    height : 28px ;
                    margin: 0px auto;
                  margin-top:67px;
                  margin-bottom: 80px;
                    font-size: 18px;
                    color: #374151;
                    line-height: 28px;
                    display: block;
                }
            }
             .centerimg{
                width: 300px;
                margin: 10px auto;
                 height: 400px;
                .cenimgone{
                    width: 120px;
                    height: 190px;
                    margin: 10px auto;
                    position: relative;
                    // img{
                    //     position: absolute;
                    //     top: 0px;
                    //     left: 0px;
                    // }
                    .topimg{
                        position: absolute;
                        top: 90px;
                        left: 15px;
                        z-index: 999;

                    }
                    span{

                    display: block;
                    margin-top: 50px;
                    font-family: 'Sofia Pro';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 20px;
                        line-height: 20px;
                    }

                }
            }
            .piclist{
              display: none;
            }
            .tabs {
              display: block;
                /* height: 800px; */
                padding-top: 75px;
                /deep/ .el-carousel__arrow{
                  display: none;
                }
                /deep/ .el-carousel__indicator--horizontal {
                  .el-carousel__button{
                    width: 27px;
                    height: 3px;
                    background: #C4C4C4;
                    border-radius: 37px;
                  }
                  &.is-active .el-carousel__button{

                    background: #E83155;
                  }
                }
                .tab1 {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;

                    > div {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;
                        position: relative;
                        margin-bottom: 25px;
                        span {
                            margin-top: 15px;
                            font-size: 16px;
                            font-family: YuanZhunGBK;
                        }
                    }
                    div:last-child {
                    }
                }
            }
        }
    }

    .bodyred {
        height: 730px;
      position: relative;
      padding-top:73px;
      .img1{
        width: 117.5px;
        height: 135px;
        position: absolute;
        top:0;
        left:0;
        z-index:10;
      }
      .img2{
        width: 68px;
        height: 90.5px;
        position: absolute;
        top:0;
        left:0;
        z-index:11;
      }
      .img3{
        display: none;
      }
        // .bgCircleRed {
        //     width: 80vw;
        //     height: 80vw;
        //     border-radius: 50%;
        //     position: absolute;
        //     background: #e83155;
        //     box-shadow: 0px 4px 80px rgba(6, 41, 70, 0.25);
        //     top: -40vw;
        //     left: -40vw;
        //     display: flex;
        //     justify-content: center;
        //     align-items: center;

        //     > div {
        //         width: 50vw;
        //         height: 50vw;
        //         border-radius: 50%;

        //         background: #e83155;
        //         box-shadow: 0px 4px 80px rgba(6, 41, 70, 0.25);
        //     }
        // }
        /* .bgCircleRed {
            position: absolute;
            top: 0;
            left: 0;
            width: 190px;
            height: 245px;
            background: url('../assets/img/Ellipsemobile2.png') no-repeat;

            > div {
                position: absolute;
                top: 0;
                left: 0;
                width: 130px;
                height: 181px;

                background: url('../assets/img/Ellipsemobile.png') no-repeat;
            }
        } */

        .youshiBox{
          width:360px;
            height: 100%;
            z-index:13;
            position: relative;
            .title-2{
              p{
                position: absolute;
                // top:-30px;
                left:50%;
                top: -10px;
                margin-left:-70px;
                  z-index:22;
                  font-size: 20px;
                 color: #000000;
                 font-family: MuliSemiBold;
                 font-weight: 600;
              }

                img{
                  position: absolute;
                    // top:-48px;
                    left:50%;
                    margin-left:-125px;
                    z-index:21;
                // z-index:21;
                    width: 250px;
                    height: 67.85px;
                }
                // .title-1{
                //   position: absolute;
                //   top:-45px;
                //   left:50%;
                //   margin-left:-111px;
                //     z-index:22;
                //     font-size: 32px;
                //     color: #FFFFFF;
                // }
            }

            .THRbox {
              width:100%;
                margin-top: 134px;
                .whitebox {
                  width:100%;
                    height: 112px;
                    flex:1;
                    margin-right:32px;
                    background: #FFFFFF;
                    /* Drop shadow/Small */

                    box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px -1px rgba(16, 24, 40, 0.1);
                    border-radius: 6px;


                    // width: 30vw;
                    /*  width: 384px; */
                    background-color: #fff;
                    border-radius: 6px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    align-items: center;
                    margin-bottom:28px;
                    span:first-child {
                        color : #0085F2 ;
                        font-size: 28px;
                       font-weight: 700;
                    font-family: MuliBold;
                    }
                    span {
                        font-size: 16px;
                        color: #6B7280;

                    }
                }
            }
        }
        .jiangpai {
            display: none;
        }
        .iphone {
            width: 542.32px;
            height: 276.74px;
            position: absolute;
            background: #ffffff;
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
            bottom: 260px;
            left: -80px;
            border-radius: 47px;
            transform: rotate(-10.16deg);
            z-index: 2;
            display: block;

            img {
                width: 518.92px;
                position: absolute;
                left: 13px;
                top: -20px;
                transform: rotate(10.16deg);
            }
        }

        .guide {
            position: absolute;
            /*  background: url('../assets/img/Groupguird.png') no-repeat; */
            bottom: 0;
            z-index: 13;
            right: 0;
            width: 226.55px;
            // height: 345.92px;
        }
        // .guideApp {
        //     position: absolute;
        //     background: url('../assets/img/GroupApp.png') no-repeat;
        //     bottom: 0;
        //     z-index: 1;
        //     right: 0;
        //     width: 191px;
        //     height: 289px;
        // }
        .appCircleRIG {
          display: block;
            position: absolute;
            bottom: 0;
            right: 0;
            width: 369px;
            height: 337px;
            background: url('../assets/img/appcircle.png');
            > div {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 271px;
                height: 234px;
                background: url('../assets/img/appcircle2.png');
            }
        }
    }
    .bgWhite {
        background: #fff;
        text-align: center;
        .whiteBg {
          width:360px;
            padding: 160px 0 67px 0;
            font-size: 32px;
            position: relative;
            >img{
              margin-top:30px;
            }

            .cerebrumAPP {
                z-index: 10;
                position: absolute;
                background: url('../assets/img/Framecere.png') no-repeat;
                top: -55px;
                // margin-bottom: -62px;
                right: 50%;
                margin-right: -63px;
                width: 126px;
                height: 123px;
            }
        }


				.video_box{
					width:100%;
						margin-top:72px;
					.video_info{
						height:186px;
						margin-right:0;
						margin-bottom:56px;
					}
        }
        .swiperfor {
            margin-top: 80px;
            text-align: center;
            > div:nth-child(1) {
                font-size: 14px;
               color: #0085F2;
                margin-bottom:15px;
                font-weight: 700;
                font-family: MuliBold;
            }
            > div:nth-child(2) {
                font-size: 32px;
                color: #000;
                margin-bottom:80px;
                font-weight: 600;
                font-family: MuliSemiBold;
            }
        }
    }
    // .star-left {
    //     width: 90%;
    // }
    // .star-item {
    //     border: 1px solid #f1f1f1;
    //     border-radius: 21px;
    //     padding: 25px;
    //     box-sizing: border-box;
    // }
    // .arrow-left,
    // .arrow-right {
    //     display: none;

    // }

    .star-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .star-left {
            width:320px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 30px;
            font-size: 12px;

            label {
                font-size: 21.654px;
                line-height: 100%;

                text-align: center;

                color: #000000;
            }

            .star-img-big {
                width: 190.07px;
                height: 39.7px;
            }
        }
         .start-content{
             display: flex;
            flex-direction: column;
            justify-content: center;
            //  margin-left:60px;
             .info-feed{

                box-shadow: 12px 8px 33px rgba(0, 0, 0, 8%);
                height: 179px;
                width: 201px;
                padding: 19px 13px;
                margin-bottom:40px;
                &:nth-child(3){
                }
                h6 {
                    color: #000;
                    // display: block;
                    // width: 183px;
                    font-size: 20px;
                    z-index: 100040;
                    line-height: 1.1;
                    letter-spacing: 0;
                    text-align: left;
                    text-align-last: left;
                    font-style: normal;
                    display: block;
                    margin: 0 11px;
                    margin-bottom: 13px;
                    font-family: "times new roman";
                    font-weight: bold;
                }
                p {
                    color: #000;
                    display: block;
                    // width: 177px;
                    font-size: 14px;
                    line-height: 1.4;
                    letter-spacing: 0;
                    font-style: normal;
                    text-align: left;
                    text-align-last: left;
                    margin: 0 8px;
                    font-family: "open sans";
                }
                img {
                    width: 190.07px;
                    height: 39.7px;
                    margin-bottom: 6px;
                }
             }
         }

    }
    .btn_lq {
        width: 100%;
        height: 47px;
        border-radius: 25px;
        background: #ff5979;
        color: white;
        margin: 70px auto 0;
        font-size: 18px;
        justify-content: center;
        align-items: center;
        display: flex;
    }
    // .bgWhite {
        // > img {
        //     width: 54.37px;
        //     height: 57.48px;

        //     margin: 30px auto 60px;
        // }
    // }
    footer {
        background: #1068AF;
        position: relative;
        // height: 840px;
        // padding: 0 20px;
        text-align: center;
        position: relative;

        .img_m3{
            width:280px;
            height:280px;
            position: absolute;
            top:0;
            right:0;
            z-index:10;
        }
        .img_m4{
            width:160px;
            height:160px;
            position: absolute;
            top:0;
            right:0;
            z-index:11;
        }
        .img1,.img2{
            display: none;
        }
        // > span:first-child {
        //     padding-top: 100px;
        //     display: block;
        //     font-size: 18px;
        //     color: white;
        //     z-index: 12;
        //     position: inherit;
        // }

        .footer_box{
            width:360px;
            position: inherit;
            z-index:12;
            padding-bottom: 150px;

           h3{
               font-size: 14px;
               color: #FFFFFF;
               margin-top:70px;
           }
           h1{

                font-size: 36px;
                line-height: 44px;
                text-align: center;
                letter-spacing: -0.02em;

                color: #FECE0C;
           }
            .aboutus {
                margin-top: 20px;
                display: block;
                color: #fece0c;
                position: inherit;
                font-size: 36px;
                font-weight: 700;
                font-family: MuliBold;
            }
            .londtitle {
                // width: 667px;
                margin: 15px auto 0;
                white-space: normal;
                word-break: break-word;
                // word-wrap: break-word;
                color: white;
                font-size: 18px;
                line-height: 44px;
                position: inherit;

                padding:  0px 15px;
            }
            .btn_yellow {
                width: 100%;
                height: 48px;
                background: #fece0c;
                margin: 68px auto 0;
                border-radius: 25px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                color:#333;
                margin-bottom:160px;
            }
        }
        .fooimg1 {
            display: none;
        }
        .fooimg2 {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 200px;
        }
        .fooimg3 {
            position: absolute;
            width: 64.75px;
            height: 69.07px;
            right: 0;
            bottom: 58px;
        }
        .circleRightTop {
            position: absolute;
            width: 473px;
            height: 519px;
            top: 0;
            right: 0;
            img:last-child {
                position: absolute;
                top: 0;
                right: 0;
            }
        }
        .circleRightTopApp {
            position: absolute;
            width: 242px;
            height: 229px;
            top: 0;
            right: 0;
            img:last-child {
                position: absolute;
                top: 0;
                right: 0;
            }
        }
    }
    .moliepost {
        position: inherit !important;
    }
     .bodysses{
       background: #1068AF;

        padding: 0;
    }
    .rowimg{
        position: relative;
          background: url('../assets/img/studentapp.png') no-repeat;
          .imgsen{
              display: none;
          }
           color: #0085F2;
    }
    #mien{
        font-weight: 700;
        font-family: MuliBold;
    }

}

/deep/ .el-form--label-top .el-form-item__label {
    padding: 0;
    line-height: inherit;
}
/* el-carousel__indicator--horizontal  */
a {
    text-decoration: none;
    color: black;
}
.lastitem {
    margin-right: calc(50vw - 49.5px - 15px);
}
/deep/.el-input__inner:focus-within {
     border:1px solid hsl(0, 0%, 0%);
}
/deep/section .right .forms_submit .el-form-item .el-form-item__content .el-input__inner:focus{
     border:1px solid hsl(0, 0%, 0%);
}
/deep/.el-select{
    text-align: left;
}
/deep/.el-select{
    .el-input__inner{
        padding: 0  0 0 12px;
         background-image: -webkit-linear-gradient(left, rgba(0, 0, 0,1), rgba(0, 0, 0, 0.2));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .el-input__suffix{
        background: #FFFFFF;
        height: 40px;
        top:5px;
    }

}
/deep/ section .right .forms_submit .el-form .el-form-item .el-form-item__content .el-select .el-input__inner{

font-style: normal;
font-weight: 500;
font-size: 14px;
color: #111827;

}


</style>>



// WEBPACK FOOTER //
// src/components/Index.vue